export default __webpack_public_path__ + "static/media/unlock-gray-icon.7a14571d.svg";